<template>
    <div>

        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="laboratorios"
                        :validations="validations.unidade"
                        label="Laboratório"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        :disabled="model.unidadeDisabled ? true : false"
                        value-field="unidadeId"
                        @change="resetForm"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        :validations="validations.infraestrutura"
                        textField="nome"
                        v-model="model.infraestruturaId"
                        :disabled="model.unidadeDisabled ? true : false"
                        valueField="id"
                        show-default-option
                        @change="resetForm"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-form
            ref="FormUsuario"
        >

            <rkm-row v-if="model.infraestruturaId">

                <rkm-col cols="12">

                    <rkm-area
                        title="Profissionais"
                        type="fieldset"
                    >

                    <rkm-row class="flex-nowrap">

                            <rkm-col class="flex-grow-1">
                                <rkm-form-input-autocomplete
                                    :repository="repositories.usuario"
                                    :request-query-string-params="requestQueryStringParamsUsuario"
                                    :search-fields="fields.autocomplete.usuario"
                                    text-field="cidadaoNome"
                                    :validations="validations.usuario"
                                    :disabled="model.unidadeId && model.infraestruturaId ? false : true"
                                    label="Profissional"
                                    placeholder="Digite o nome ou número do conselho profissional"
                                    v-model="model.usuario"
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-select
                                    label="CBO"
                                    :options="ocupacao"
                                    :validations="validations.ocupacao"
                                    textField="codigoNome"
                                    v-model="model.ocupacaoId"
                                    valueField="id"
                                    show-default-option
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-0">
                                <rkm-button
                                    :label="false"
                                    color="primary"
                                    @click.stop="$refs.Form.validate(add)"
                                >
                                    Incluir
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>

                            <rkm-col cols="12">

                                <rkm-table
                                    :fields="fieldsTable"
                                    :items="profissionais"
                                    ref="Table"
                                    sort-by="usuarioNome"
                                    hide-filters
                                >

                                    <template v-slot:cell(actions)="{ index, item }">
                                        <rkm-button
                                            color="danger"
                                            title="Excluir"
                                            small
                                            @click.stop="handleDestroy(index, item)"
                                        >
                                            <rkm-icon icon="trash" />
                                        </rkm-button>
                                    </template>
                                </rkm-table>

                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row>

            <rkm-col
                cols="12"
                v-if="model.infraestruturaId"
            >
                <rkm-area
                    title="Faturam automaticamente pela selecionada"
                    type="fieldset"
                >
                    <FormFatura
                        ref="FormFatura"
                        :data="data"
                        :faturamentoRelacionado="faturamentoRelacionado"
                        :unidadeId="model.unidadeId"
                        :infraestruturaId="model.infraestruturaId"
                        :unidadeDisabled="model.unidadeDisabled"
                    />
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import { object, error, repository, stringCase } from '@/mixins'

// Components.
import FormFatura from './unidade-fatura/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { FormFatura },
    computed: {
        fieldsTable() {

            const fields = [
                {
                    key: 'usuarioNome',
                    label: 'Profissionais',
                    sortable: true
                },
                {
                    key: 'ocupacaoCodigoNome',
                    label: 'CBO',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]

        return fields
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
                usuario: { required: true },
                ocupacao: { required: true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        laboratorios() {
            const unidades = [];

            this.data.model.unidades.forEach(unidade => {

                if (!unidade.laboratorio) return;

                const infraestruturaId = unidade.infraestruturaId;

                const cadastrada =
                    (!this.item && this.data.model.laboratoriosFaturamento.some(principal => principal.infraestruturaId === infraestruturaId))
                        || this.data.form.laboratoriosFaturamento.some(principal => principal.infraestruturaId === infraestruturaId)
                        || this.data.model.laboratoriosFaturamento.some(item =>
                            item.faturamentoRelacionado.some(relacionada =>
                                relacionada.relacionadaInfraestruturaId === infraestruturaId
                            )
                        );

                if (!cadastrada) {

                    let unidadeInserida = unidades.find(u => u.unidadeId === unidade.unidadeId);

                    if (unidadeInserida) {
                        unidadeInserida.infraestruturas.push({
                            id: infraestruturaId,
                            nome: unidade.infraestruturaNome,
                            principal: unidade.infraestruturaPrincipal,
                        });
                    } else {
                        unidades.push({
                            unidadeId: unidade.unidadeId,
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturas: [{
                                id: infraestruturaId,
                                nome: unidade.infraestruturaNome,
                                principal: unidade.infraestruturaPrincipal,
                            }]
                        });
                    }
                }
            });

            return unidades.length
                ? unidades.sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia))
                : unidades;
        },
        infraestruturas() {

            if (!this.model.unidadeDisabled) {

                this.resetInfraestrutura()
            }

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.laboratorios.find(u => u.unidadeId === this.model.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.getPrincipal(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal.length > 0
                    ? infraestruturaPrincipal.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0))
                    : infraestruturaPrincipal
            }

            return []
        },
        requestQueryStringParamsUsuario() {

            const request = {
                withNotRegularized: true,
                withLotacoes: true,
                coleta: true,
                infraestruturaId: this.model.infraestruturaId,
            }

            return this.camelObjectKeysToSnakeRecursive(request)
        },
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            lotacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }

        this.load()
    },
    data: () => ({
        form: {
            unidades: {},
        },
        model: {
            id: null,
            unidadeId: null,
            ocupacaoId: null,
            usuario: null,
            infraestruturaId: null,
            unidadeDisabled: false,
            unidadeColeta: false,
            laboratorio: false,
            infraestrutura: []
        },
        faturamentoRelacionado: [],
        ocupacao: [],
        profissionais: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.hasIndex) {

                const objId = this.data.model.laboratoriosFaturamento.findIndex((obj => obj.id == this.item.id));
                const data = this.data.model.laboratoriosFaturamento[objId]

                this.model.id = data.id
                this.model.unidadeId = data.unidadeId
                this.model.infraestruturaId = data.infraestruturaId
                this.model.unidadeDisabled = true
                this.profissionais = this.item.profissionais
                this.faturamentoRelacionado = this.item.faturamentoRelacionado ?? []
            }
        },
        getPrincipal(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {
                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {
                this.model.infraestruturaId = null
            }
        },
        add() {

            this.$refs.FormUsuario.validate()
                .then(valid => {

                    if (!valid) return

                    const usuario = this.clone(this.model)

                    const ocupacao = this.ocupacao.find(u => u.id === this.model.ocupacaoId)

                    const hasUsuario = this.profissionais.find(cc => cc.usuarioId === this.model.usuario.id
                        && cc.ocupacaoId === this.model.ocupacaoId)

                    if (hasUsuario) {

                        this.showValidationNotification(`O usuário <strong>${ usuario.usuario.cidadaoNome }</strong> e a
                            ocupação <strong>${ ocupacao.codigoNome }</strong> já estão cadastrados.`)

                        return false
                    }

                    usuario.usuarioId = usuario.usuario.id
                    usuario.usuarioNome = usuario.usuario.cidadaoNome
                    usuario.ocupacaoCodigoNome = ocupacao.codigoNome

                    this.profissionais.push(usuario)
                    this.resetForm()
                })
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        if (this.hasUnidadeParametrizada()) {

                            this.showValidationNotification(
                                "Unidade já parametrizada com o local de atendimento."
                            )

                            return
                        }

                        const unidade = this.data.form.unidades.find(u => u.id === this.model.unidadeId)
                        const infraestrutura = this.infraestruturas.find(u => u.id === this.model.infraestruturaId)

                            if (this.index == null) {

                            this.model.id = this.uniqueId('unidade' + new Date().getTime())
                        }

                        const param = {
                            id: this.model.id,
                            unidadeId: unidade.id,
                            nomeFantasia: unidade.nomeFantasia,
                            infraestrutura: this.model.infraestrutura,
                            infraestruturaId: infraestrutura.id,
                            infraestruturaNome: infraestrutura.nome,
                            infraestruturaPrincipal: infraestrutura.principal,
                            faturamentoRelacionado: this.faturamentoRelacionado,
                            profissionais: this.profissionais,
                            alterado: true,
                        }

                        if (this.hasIndex) {

                            const objIndex = this.data.model.laboratoriosFaturamento.findIndex((obj => obj.id == this.model.id));

                            this.$set(this.data.model.laboratoriosFaturamento, objIndex, this.clone(param))
                        }
                        else {

                            this.data.model.laboratoriosFaturamento.push(this.clone(param))
                        }

                        this.$emit('save', this.clone(param))
                })
        },
        hasUnidadeParametrizada() {

            return this.data.model.laboratoriosFaturamento.find((unidade) => unidade.id !== this.model.id
                && unidade.infraestruturaId === this.model.infraestruturaId)
        },
        resetInfraestrutura() {

            this.model.infraestruturaId = null
        },
        loadLotacoes(lotacao) {

            lotacao.map(ocupacao => {
                this.ocupacao.push(ocupacao.ocupacao)
            })

            if (this.ocupacao.length === 1) {
                this.model.ocupacaoId = this.ocupacao[0].id
            }
        },
        resetForm() {

            this.ocupacao = []
            this.model.usuario = null
            this.model.ocupacaoId = null

            this.$nextTick(() => this.$refs.FormUsuario.resetValidator())
        },
        handleDestroy(index, item) {

            const destroy = async () => {

                this.profissionais.splice(index, 1)
            }

            this.showDeleteConfirmation(`Deseja realmente excluir o profissional
                <strong>${ item.usuarioNome }</strong> com a ocupação
                <strong>${ item.ocupacaoCodigoNome }</strong>?`,
                destroy)
        },
    },
    mixins: [object, error, repository, stringCase ],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
    watch: {
        'model.usuario' (usuario) {

            this.ocupacao = []
            this.model.ocupacaoId = null

            if (usuario) {

                this.setLoading()

                this.repositories.lotacao.lotacoes({
                    usuario_id: usuario.id,
                    infraestrutura_id: this.model.infraestruturaId,
                })
                    .then(response => {

                        this.loadLotacoes(response.data.lotacoes)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
    }
}
</script>